<template>
    <b-tabs fill v-if="tabs.length>0">
      <b-tab v-if="tab.show === undefined || tab.show === true" :key="tabIndex" v-for="tab, tabIndex in tabs">
        <template v-if="tab.caption !== ''" slot="title">
          {{tab.caption}}
        </template>
        <FormCardRows class="mt-3" :fieldRefs="fieldRefs" :form="form" v-if="tab.rows !== undefined" :rows="tab.rows"></FormCardRows>
        <FormFields class="mt-3" :fieldRefs="fieldRefs" :form="form" v-if="tab.fields !== undefined" :fields="tab.fields"></FormFields>
      </b-tab>
    </b-tabs>
</template>
<script>
  import FormCardRows from './FormCardRows'
  import FormFields from './FormFields'
export default {
  name: 'FormTabs',
  components: {
      FormCardRows,
    FormFields
  },
  props: {
    tabs: {
      type: Array,
      default: function () { return [] }
    },
    form: {
      type: Object,
      default: function () { return {} }
    },
    fieldRefs: {
      type: Array,
      default: function() { return [] }
    }
  },
  data: function () {
    return {
    }
  }
}
</script>

